import { Box, BoxProps } from "@mui/material";
import Blank from "./images/blank.png";
import type { Size } from "../types";

interface AdProps extends BoxProps {
    size?: Size;
    visual: string;
    optional_mobile_visual?: string;
    url?: string;
}

const Ad = ({ sx = {}, size, visual, optional_mobile_visual, ...rest }: AdProps) => {
    const randomNumber = Math.floor(Math.random() * 10000) + 1;
    return (
        <Box
            sx={{
                height: size !== `large` ? 139 : 250,
                display: `flex`,
                justifyContent: `center`,
                maxWidth: `100%`,
                overflow: `hidden`,
                borderRadius: size !== `large` ? 0 : 2.5,
                ...sx,
            }}
        >
            <Box
                id={randomNumber}
                onError={() => {
                    // Element is guaranteed to exist here - this IS the element that fired the error event
                    (document.getElementById(`${randomNumber}`) as HTMLImageElement).onerror = null;
                    (document.getElementById(`${randomNumber}`) as HTMLImageElement).src = Blank;
                }}
                src={`${size !== `large` && optional_mobile_visual ? optional_mobile_visual : visual}`}
                sx={{
                    height: `100%`,
                    cursor: `pointer`,
                }}
                component="img"
                {...rest}
            />
        </Box>
    );
};

export default Ad;
